export default "__VITE_ASSET__C$mAQlJM__"